import { PropsWithChildren, useEffect } from 'react'
import { EdsProvider } from '@equinor/eds-core-react'
import { ModalProvider } from 'react-modal-hook'

import { Router } from '@/routes/Router'
import { CreateRouterProps } from '@/routes/types'

import GlobalStyle from '@/styles/globalStyle'
import { themeAtom } from './core/store/globalStore'
import { useAtomValue } from 'jotai'
import { setupServiceWorker } from '@/service-worker/registerServiceWorker'
import styled from 'styled-components'

const ThemeProvider = ({ children }: PropsWithChildren) => {
    const theme = useAtomValue(themeAtom)

    return <EdsProvider density={theme}>{children}</EdsProvider>
}

const App = ({ strategy, initialPathname }: CreateRouterProps) => {
    useEffect(() => {
        setupServiceWorker()
    }, [])
    return (
        <>
            <SafeAreaWrapper>
                <GlobalStyle />
                <ThemeProvider>
                    <ModalProvider>
                        <Router strategy={strategy} initialPathname={initialPathname} />
                    </ModalProvider>
                </ThemeProvider>
            </SafeAreaWrapper>
        </>
    )
}

const SafeAreaWrapper = styled.div`
    @media (max-width: 1024px) {
        position: relative;
    }
`

export default App
